module.exports = __webpack_public_path__ + "img/counsel_write_title.fbd3655c.jpg";